import { render, staticRenderFns } from "./wheatissue.vue?vue&type=template&id=5090ce70&scoped=true&"
import script from "./wheatissue.vue?vue&type=script&lang=js&"
export * from "./wheatissue.vue?vue&type=script&lang=js&"
import style0 from "./wheatissue.vue?vue&type=style&index=0&id=5090ce70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5090ce70",
  null
  
)

export default component.exports